// section-custom-content.js

function initCustomContentSection(sectionId, backendSubmitted) {
  const container = document.querySelector(`.section-${sectionId}`);
  if (!container) return;

  const cards = container.querySelectorAll('.we-clickable-card');
  const modal = document.getElementById('custom-we-modal');
  const closeBtn = modal ? modal.querySelector('.we-close-btn') : null;
  const hiddenTagInput = document.getElementById('selected_card_tag');
  const form = document.getElementById('we_lead_form');
  const responseContainer = document.getElementById('we-ajax-response-container');

  function hasAlreadySubmitted() {
    return backendSubmitted || localStorage.getItem('we_form_submitted') === 'true';
  }

  if (!modal) return;

  cards.forEach(card => {
    card.addEventListener('click', function(e) {
      e.preventDefault(); 
      
      if (hasAlreadySubmitted()) {
        alert('you already submit on a team');
        return; 
      }

      const cardName = this.getAttribute('data-we-event');
      if (hiddenTagInput && cardName) {
        hiddenTagInput.value = cardName; 
      }
      
      if(responseContainer) responseContainer.innerHTML = '';
      if(form) {
        const wrapper = form.querySelector('.form-group-wrapper');
        if(wrapper) wrapper.style.display = 'block';
      }
      
      modal.style.display = 'flex';
    });
  });

  if (form && !form.dataset.listenerAttached) {
    form.dataset.listenerAttached = 'true';
    form.addEventListener('submit', function(e) {
      e.preventDefault(); 

      const submitButton = form.querySelector('button[type="submit"]');
      if(submitButton) submitButton.disabled = true;

      const formData = new FormData(form);

      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(() => {
        localStorage.setItem('we_form_submitted', 'true');
        
        if (responseContainer) {
          responseContainer.innerHTML = `
            <div class="we-custom-success-alert">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span>Thanks for subscribing</span>
            </div>
          `;
        }
        const formWrapper = form.querySelector('.form-group-wrapper');
        if(formWrapper) {
          formWrapper.style.display = 'none';
        }
      })
      .catch((error) => {
        console.error('Submission failed:', error);
        if(submitButton) submitButton.disabled = false;
      });
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => modal.style.display = 'none');
  }
  
  window.addEventListener('click', (e) => {
    if (e.target === modal) modal.style.display = 'none';
  });
}